import httpClient from "./httpClient";

const prefix = "/periodicities";

export async function getPeriodicities() {
  return (await httpClient.get(`${prefix}`)).data;
}
